<template>
    <projeto-resultados 
        :projeto-id="projetoIdBase" 
        :titulo="titulo" 
        :colunas="colunas" 
        :rubrica="rubrica" 
        :componente="componente" 
        :endpoint="endpoint" 
        @update="update"

        :chave-permissao="chavePermissao"
        :projeto-editavel="projetoEditavel"
    />
</template>
<script>
import helpers from "@/common/utils/helpers";
import ProjetoResultados from "../componentes/Resultados"
export default {
    components : {
        ProjetoResultados
    },
    props : ['projetoId', 'projetoIdBase', 'endpoint', 'chavePermissao','projetoEditavel'],
    data : () => ({
        colunas : [
            { key: 'tipo', label: "Tipo",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            { key: "dataConclusao", label:"Data",
                formatter: (value) => {
                    if (value) return helpers.formatarDataBr(value);
                },
            },
            { key: "areaPesquisa", label: "Nome da publicação", },
        ],
        componente : 'capacitacao-profissional',
        rubrica : 'capacitacao-profissional',
        titulo : 'Capacitação Profissional',
    }),
    methods : {
        update : function(){
            this.$emit('update');
        }
    }
}
</script>
<style>
    
</style>